import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ApplicationRef, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { LocationService } from '../services/location.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as mapboxgl from 'mapbox-gl';

import Noty from 'noty';
import { EmojiServiceService } from '../services/emoji-service.service';
import { GeoService } from '../services/geo.service';
import { GameService } from '../services/game.service';
import * as turf from '@turf/turf';
declare let L;
import Swal from "sweetalert2";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WalkthroughModalComponent } from '../components/walkthroughModal/walkthroughModal.component';
import { UtilsService } from '../services/utils.service';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { LocaleService } from '../services/locale.service';
import { StorageService } from '../services/storage.service';
import * as PubNub from 'PubNub';
import { Subject } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { SoundService } from '../services/audio.service';



@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})
export class GameComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('scanner', { static: false }) scanner: ZXingScannerComponent;
  @ViewChild('camCorderModal', { static: false }) camCorderModal;
  @ViewChild('textInput', { static: false }) textInputModal: any;
  hasDevices: boolean;
  hasPermission: boolean;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo;
  pubnub;
  dynamic_url;
  isNotesImageCheck = false;
  bgColor1;
  playerRanking = 0;
  currentCardIndex = 0;
  notPositioned = false;
  gameCountdown;
  inactivityCountdown;
  playerSynch;
  otherPlayerSynch;
  battleCircleCountdown;
  geoLocationWatch;
  private autoFreezeTimeout: any;
  private autoFreezeClearTimeout: any;
  // Battle circle tuning for dynamic question creation
  private dynamicBattleCircleInitialRadiusKm: number | null = null;
  private dynamicBattleCircleMinRadiusKm: number = 0.15; // never shrink below this (visibility + fairness)
  private readonly EVENT_HALL_TOUR_ID = '695bf6db9933ee260e525657';
  mapStyle = 'mapbox://styles/ercseypeter1/ckksgqro810vr17ord4zmvbum';
  swiperConfig = {
    spaceBetween: 10,
    loop: false,
    slidesPerView: 2,
    loopedSlides: true,
    centeredSlides: false,
  };
  imageComment: any;
  perks = [
    {
      name: 'freeze',
      description: 'You can freeze all players for 30 seconds',
      image: './assets/images/emoji/ice.png',
      teamPerk: true,
      date: new Date(),
      point: 100,
      defaultPoint: 100,
      used: null,
    },
    {
      name: 'double',
      image: './assets/images/emoji/slot.png',
      description: 'Double your points at the next question',
      point: 100,
      date: new Date(),
      defaultPoint: 100,
      used: null,
    },
  ];
  activeLayers = [];
  messageHistory = [];
  previewImage;
  currentCard: any;
  firstGameNoteRun = true;
  activeLevel = 1;
  pageConfig = {
    showQrReader: false,
    playerId: null,
    remainingMinutes: 0,
    center: [-74.2605542, 40.6971478],
    zoom: [12],
    lastPositionRefresh: moment(),
    remainingSentSlots: null,
    initialQuestion: false,
    showcaseIsActive: false,
    virtualModeActive: false,
    showLocationSimulator: false,
  };
  loaders = {
    getPosition: false,
  };
  museumPlayers = [];
  activeBounds = [];
  availableGifs = [];
  activePerks = {
    bomb: false,
    blank_map: false,
  };
  createdBombPerkBy;
  fakeUsers = [];
  fakeUsersInterval;;
  map;
  passedNotifications = [];
  passedTimedQuestion = [];

  gameNotes = [];


  locales = {
    questionsAnswered: this.localeService.getTrans('questions answered'),
    remainingQuestions: this.localeService.getTrans('remaining questions'),
  }

  isImageUploading = false;

  currentCardObj = null;

  imageMessage = '';
 
  textInputValue = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private locationService: LocationService,
    public emojiService: EmojiServiceService,
    private appRef: ApplicationRef,
    public geoService: GeoService,
    public gameService: GameService,
    private ngZone: NgZone,
    private modalService: NgbModal,
    private utilsService: UtilsService,
    private changeDetectorRef: ChangeDetectorRef,
    public localeService: LocaleService,
    private storageService: StorageService,
    private cd: ChangeDetectorRef,
    private location: LocationStrategy,
    private audioService: SoundService
  ) {
    this.perks = [
      {
        name: 'freeze',
        description: this.localeService.getTrans(
          'You can freeze all players for 30 seconds'
        ),
        image: './assets/images/emoji/ice.png',
        teamPerk: true,
        date: new Date(),
        point: 100,
        defaultPoint: 100,
        used: null,
      },
      {
        name: 'double',
        image: './assets/images/emoji/slot.png',
        description: this.localeService.getTrans(
          'Double your points at the next question'
        ),
        point: 100,
        date: new Date(),
        defaultPoint: 100,
        used: null,
      },
    ];

   
  

    /*  history.pushState(null, null, window.location.href);  
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });   */

    this.gameService.geoServiceSubject$.subscribe((val: any) => {
      if (val && val.bomb) {
        this.activePerks.bomb = false;
        this.http
          .post(environment.baseUrl + 'games/markBombPassed', {
            gameId: this.gameService.pageConfig.g,
            playerId: this.route.snapshot.paramMap.get('p'),
            createdBombPerkBy: this.createdBombPerkBy,
          })
          .subscribe((data: any) => {
            this.createdBombPerkBy = null;
            this.changeDetectorRef.detectChanges();
          });
      }
    });

    if (
      this.route.snapshot.paramMap.get('g') &&
      this.route.snapshot.paramMap.get('p')
    ) {
      this.pageConfig.playerId = this.route.snapshot.paramMap.get('p');
      if (this.route.snapshot.paramMap.get('inGame')) {
        this.pageConfig.initialQuestion = true;
      }
      this.gameService.pageConfig.g = this.route.snapshot.paramMap.get('g');
      this.gameService.pageConfig.p = this.route.snapshot.paramMap.get('p');

      if (this.locationService.isValidBrowser()) {
        this.getGame(
          this.route.snapshot.paramMap.get('g'),
          this.route.snapshot.paramMap.get('p'),
          true
        );
        //this.geoService.updateUser();
      }
    } else {
      this.navigateBack();
    }
  }

  openPopup(event: any, quest: any) {
    console.log('openPopup', quest);
  }

getGameQuests() {
  let quests;

  if (this.gameService.activeGame.tourId.isQR && this.gameService.me && this.gameService.me.passedQuests) {
    quests = _.map(_.filter(this.gameService.activeGame.quests, (q) => {
      return q.level === this.activeLevel && !q.isEndPOITimeline;
    }), (q1: any) => {
      return _.merge(q1, {
        isUpcoming: this.gameService.me.passedQuests.indexOf(q1._id) === -1
      });
    });
  } else {
    quests = _.map(_.filter(this.gameService.activeGame.quests, (q) => {
      return !q.isEndPOITimeline && !q.isTimedQuestion && q.isVisible;
    }), (q1: any) => {
      return _.merge(q1, {
        isUpcoming: this.gameService.me.passedQuests.indexOf(q1._id) === -1
      });
    });
  }

  // ✅ Only show next upcoming if sequence + showOnlyNext are true
  const tour = this.gameService.activeGame?.tourId;
  if (tour?.isSequenceGame  && tour?.isShowOnlyNextQuestion) {
    return quests.filter(q => q.isUpcoming).slice(0, 1);
  }

  return quests;
}

  trackByQuests(index, item) {
    return item._id + '_' + item.isUpcoming;
  }

  getCircleRadius() {
    let defaultRadius = 10;
    let q = this.gameService.activeGame.quests.length;
    if (q < 10) {
      return defaultRadius;
    } else if (q >= 10 && q < 15) {
      return defaultRadius;
    } else if (q >= 15 && q < 20) {
      return defaultRadius;
    } else if (q >= 20 && q < 25) {
      return defaultRadius + 5;
    } else if (q >= 25 && q < 30) {
      return defaultRadius + 15;
    } else {
      return defaultRadius + 50;
    }
  }

  private clampNumber(n: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, n));
  }

  private isEventHallGame(): boolean {
    return this.gameService?.activeGame?.tourId?._id === this.EVENT_HALL_TOUR_ID;
  }

  private isOutdoorGame(): boolean {
    // "Outdoor" here means: not QR, not indoor mode, not event hall raster game
    const isQRGame = !!this.gameService?.activeGame?.tourId?.isQR;
    const isIndoorMode = !!this.gameService?.activeGame?.indoorMode;
    return !isQRGame && !isIndoorMode && !this.isEventHallGame();
  }

  private scheduleAutoFreezeForOutdoorDemo(): void {
    // Safety: only do this in virtual demo mode
    if (!this.pageConfig?.virtualModeActive) return;
    if (!this.isOutdoorGame()) return;

    if (this.autoFreezeTimeout) clearTimeout(this.autoFreezeTimeout);
    if (this.autoFreezeClearTimeout) clearTimeout(this.autoFreezeClearTimeout);

    this.autoFreezeTimeout = setTimeout(() => {
      // Game might have ended / component destroyed
      if (!this.gameService?.activeGame) return;

      this.gameService.interimSettings.freezeActive = true;
      try {
        this.changeDetectorRef.detectChanges();
      } catch {}

      // Keep it for 30s (same UX as real freeze)
      this.autoFreezeClearTimeout = setTimeout(() => {
        this.gameService.interimSettings.freezeActive = false;
        try {
          this.changeDetectorRef.detectChanges();
        } catch {}
      }, 30000);
    }, 60000);
  }

  shouldShowRasterLayer(): boolean {
    // Event hall games should show raster map; virtual mode also shows raster if available.
    const hasRaster =
      !!this.gameService?.activeGame?.partner?.raster_image_url &&
      this.gameService.activeGame.partner.raster_image_url.length > 0;
    return hasRaster && (this.pageConfig.virtualModeActive || this.isEventHallGame());
  }

  private computeBoundsFromQuests(quests: any[]): [[number, number], [number, number]] | null {
    const pts = (quests || []).filter((q) => typeof q?.lng === 'number' && typeof q?.lat === 'number');
    if (!pts.length) return null;
    const lngs = pts.map((q) => q.lng);
    const lats = pts.map((q) => q.lat);
    return [
      [Math.min(...lngs), Math.min(...lats)],
      [Math.max(...lngs), Math.max(...lats)],
    ];
  }

  private focusMapOnMarkers(): void {
    if (!this.map || !this.gameService?.activeGame) return;
    const isQRGame = !!this.gameService.activeGame.tourId?.isQR;
    if (isQRGame || this.isEventHallGame()) return;

    // Use visible markers (same list as rendered)
    const quests = this.getGameQuests?.() || this.gameService.activeGame.quests || [];
    const bounds = this.computeBoundsFromQuests(quests);
    if (!bounds) return;

    try {
      this.map.fitBounds(bounds, { padding: 60, duration: 0 });
    } catch {}
  }

  private focusMapOnRaster(): void {
    if (!this.map || !this.shouldShowRasterLayer()) return;
    const rasterLayer = this.activeLayers?.[0] || this.gameService.activeGame?.partner?.raster_image_url?.[0];
    if (!rasterLayer?.coordinates || rasterLayer.coordinates.length < 4) return;

    const lngs = rasterLayer.coordinates.map((c) => c[0]);
    const lats = rasterLayer.coordinates.map((c) => c[1]);
    const bounds: [[number, number], [number, number]] = [
      [Math.min(...lngs), Math.min(...lats)],
      [Math.max(...lngs), Math.max(...lats)],
    ];

    try {
      this.map.fitBounds(bounds, { padding: 40, duration: 0 });
    } catch {}
  }

  private computeDynamicBattleCircleInitialRadiusKm(centerLngLat: [number, number]): number {
    // Use quest spread to size the initial radius so the border is visible immediately.
    // This prevents the "huge circle you can't see until the last minutes" problem.
    // Prefer the same quest subset we render on the map (visible / not timed / etc.)
    let visibleQuests: any[] = [];
    try {
      visibleQuests = (this.getGameQuests?.() || []) as any[];
    } catch {
      visibleQuests = [];
    }
    const quests = (visibleQuests.length ? visibleQuests : (this.gameService?.activeGame?.quests || [])).filter(
      (q) => typeof q?.lng === 'number' && typeof q?.lat === 'number'
    );
    if (!quests.length) {
      return 0.8; // fallback
    }

    const centerPoint = turf.point(centerLngLat);
    let maxDistKm = 0;
    for (const q of quests) {
      const d = turf.distance(centerPoint, turf.point([q.lng, q.lat]), { units: 'kilometers' });
      if (d > maxDistKm) maxDistKm = d;
    }

    // Add a modest buffer so the circle comfortably contains the outermost *visible* markers,
    // without becoming so large that the border is off-screen at typical marker-zoom levels.
    const bufferKm = Math.max(0.1, maxDistKm * 0.15);
    const initial = maxDistKm + bufferKm;

    // Cap extremes aggressively for dynamic games to keep the border visible early.
    // If a tour has very spread-out markers, we intentionally do NOT try to cover all of them at game start.
    const clamped = this.clampNumber(initial, 0.25, 1.2);
    console.log('[battle-circle][dynamic] maxDistKm=', maxDistKm.toFixed(2), 'initialKm=', initial.toFixed(2), 'clampedKm=', clamped.toFixed(2));
    return clamped;
  }

  getEndPoi() {
    return _.find(this.gameService.originalQuests, (x) => {
      return x.isEndPoi === true;
    });
  }

  drawCircle(isInit?) {
    if (
      this.gameService.activeGame.quests &&
      this.gameService.activeGame.quests.length
    ) {
      if (this.map) {
        if (this.map.getLayer('state-borders')) {
          this.map.removeLayer('state-borders');
          this.map.removeSource('state-borders');
        }
      }

      if (this.gameService.activeGame.quests) {
        let center;
        let radius;
        let circle;
        const isDynamic = !!this.gameService?.activeGame?.tourId?.isDynamicQuestionCreation;
        const totalMinutes = this.gameService?.activeGame?.tourId?.length || 0;
        const timeLeft = this.pageConfig.remainingMinutes || 0;
        const timeLeftRatio =
          totalMinutes > 0 ? this.clampNumber(timeLeft / totalMinutes, 0, 1) : 0;

        if (
          this.gameService.activeGame &&
          !this.gameService.activeGame.isEndPOI
        ) {
          center = this.getFeatureCenter();
          if (isDynamic) {
            const centerLngLat: [number, number] = [
              center.geometry.coordinates[0],
              center.geometry.coordinates[1],
            ];
            if (this.dynamicBattleCircleInitialRadiusKm === null) {
              this.dynamicBattleCircleInitialRadiusKm =
                this.computeDynamicBattleCircleInitialRadiusKm(centerLngLat);
              // Keep min radius proportional-ish, but not too small
              this.dynamicBattleCircleMinRadiusKm = this.clampNumber(
                this.dynamicBattleCircleInitialRadiusKm * 0.2,
                0.12,
                0.5
              );
            }
            radius =
              this.dynamicBattleCircleMinRadiusKm +
              (this.dynamicBattleCircleInitialRadiusKm - this.dynamicBattleCircleMinRadiusKm) *
                timeLeftRatio;
          } else {
            radius = this.pageConfig.remainingMinutes / this.getCircleRadius();
          }

          if (isInit) {
            this.pageConfig.center = [
              center.geometry.coordinates[0],
              center.geometry.coordinates[1],
            ];
          }
          circle = turf.circle(center.geometry.coordinates, radius, {
            steps: 20,
            units: 'kilometers',
          });
        } else {
          let endPoi = this.getEndPoi();

          center = [endPoi.lng, endPoi.lat];
          if (isDynamic) {
            const centerLngLat: [number, number] = [endPoi.lng, endPoi.lat];
            if (this.dynamicBattleCircleInitialRadiusKm === null) {
              this.dynamicBattleCircleInitialRadiusKm =
                this.computeDynamicBattleCircleInitialRadiusKm(centerLngLat);
              this.dynamicBattleCircleMinRadiusKm = this.clampNumber(
                this.dynamicBattleCircleInitialRadiusKm * 0.2,
                0.12,
                0.5
              );
            }
            radius =
              this.dynamicBattleCircleMinRadiusKm +
              (this.dynamicBattleCircleInitialRadiusKm - this.dynamicBattleCircleMinRadiusKm) *
                timeLeftRatio;
          } else {
            radius = this.pageConfig.remainingMinutes / this.getCircleRadius();
          }
          circle = turf.circle(center, radius, {
            steps: 20,
            units: 'kilometers',
          });
        }

        this.gameService.battleCircle.data.geometry.coordinates = [
          _.map(circle.geometry.coordinates[0], (x) => {
            return [x[0], x[1]];
          }),
        ];
      }
    }
  }

  getFeatureCenter() {
    let features = [];
    let featuresTurf;
    _.forEach(this.gameService.activeGame.quests, (q) => {
      features.push([q.lng, q.lat]);
    });
    featuresTurf = turf.points(features);
    let center = turf.center(featuresTurf);
    return center;
  }

  dropPIN() {
    this.dropNoty(
      'info',
      this.localeService.getTrans('PIN to join the game: ') +
        this.gameService.activeGame.pin
    );
  }

  dropWalkthrough() {
    //this.router.navigate(['/walkthrough']);
    //const modalRef = this.modalService.open(WalkthroughModalComponent);
    //modalRef.componentInstance.mode = 'embed'
    this.clearIntervals();
    if (
      this.gameService.activeGame.partner &&
      this.gameService.activeGame.partner.isMuseum
    ) {
      this.router.navigate([
        '/museum-walkthrough',
        {
          g: this.gameService.activeGame._id,
          p: this.gameService.me.name,
          partner: this.gameService.activeGame.partner._id,
        },
      ]);
      this.gameService.activeGame = null;
    } else {
      this.router.navigate([
        '/walkthrough',
        {
          g: this.gameService.activeGame._id,
          p: this.gameService.me.name,
          m: 'embed',
        },
      ]);
    }
  }

  locateMe() {
    if (this.gameService.me && this.gameService.me.position && this.map) {
      this.map.flyTo({
        center: [
          this.gameService.me.position.lng,
          this.gameService.me.position.lat,
        ],
        duration: 0,
      });
      this.pageConfig.zoom =
        this.pageConfig.zoom[0] > 18 ? this.pageConfig.zoom : [18];
    }
  }

  hideLocationSimulator() {
    this.pageConfig.showLocationSimulator = false;
  }

  initializeFakeUsers() {
    // Create 5-8 fake users with random names, points, and avatars
    const fakeNames = ['Alex', 'Sam', 'Jordan', 'Taylor', 'Casey', 'Morgan', 'Riley', 'Quinn'];
    const numFakeUsers = Math.floor(Math.random() * 4) + 5; // 5-8 fake users
    const maxAvatarCount = this.emojiService?.getEmojis?.().length || 19; // currently 0..18
    
    this.fakeUsers = [];
    for (let i = 0; i < numFakeUsers; i++) {
      const randomName = fakeNames[Math.floor(Math.random() * fakeNames.length)] + Math.floor(Math.random() * 100);
      const randomAvatar = Math.floor(Math.random() * maxAvatarCount); // stays within available emoji indices
      const randomPoints = Math.floor(Math.random() * 500) + 50; // 50-550 points
      
      this.fakeUsers.push({
        _id: 'fake_' + i,
        name: randomName,
        points: randomPoints,
        avatarIndex: randomAvatar,
        lng: null,
        lat: null,
        isFinished: false,
        isFake: true // Flag to identify fake users
      });
    }
    
    // Set initial positions near POIs
    this.updateFakeUsersPositions();
    
    // Update positions every 10 seconds
    if (this.fakeUsersInterval) {
      clearInterval(this.fakeUsersInterval);
    }
    this.fakeUsersInterval = setInterval(() => {
      this.updateFakeUsersPositions();
    }, 10000);
  }

  updateFakeUsersPositions() {
    if (!this.pageConfig.virtualModeActive || this.fakeUsers.length === 0) {
      return;
    }
    
    const quests = this.getGameQuests();
    if (!quests || quests.length === 0) {
      return;
    }
    
    // Update each fake user's position near a random POI
    this.fakeUsers.forEach((fakeUser) => {
      const randomQuest = quests[Math.floor(Math.random() * quests.length)];
      if (randomQuest && randomQuest.lng && randomQuest.lat) {
        // Add small random offset (within ~50 meters) to position near POI
        const offsetLat = (Math.random() - 0.5) * 0.0005; // ~50 meters
        const offsetLng = (Math.random() - 0.5) * 0.0005; // ~50 meters
        
        fakeUser.lat = randomQuest.lat + offsetLat;
        fakeUser.lng = randomQuest.lng + offsetLng;
      }
    });
    
    // Update gameService arrays if they exist
    if (this.gameService.mapPlayers) {
      const realPlayers = this.gameService.mapPlayers.filter(p => !p.isFake);
      this.gameService.mapPlayers = [...realPlayers, ...this.fakeUsers];
      this.gameService.enemyMarkers = this.gameService.mapPlayers.slice(0, 10);
    }
    
    if (this.museumPlayers) {
      const realMuseumPlayers = this.museumPlayers.filter(p => !p.isFake);
      this.museumPlayers = _.orderBy([...realMuseumPlayers, ...this.fakeUsers], ['points'], ['desc']);
    }
    
    // Trigger change detection
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.autoFreezeTimeout) {
      clearTimeout(this.autoFreezeTimeout);
    }
    if (this.autoFreezeClearTimeout) {
      clearTimeout(this.autoFreezeClearTimeout);
    }
    if (this.fakeUsersInterval) {
      clearInterval(this.fakeUsersInterval);
    }
    // Cleanup other intervals/subscriptions if needed
    if (this.gameCountdown) {
      clearInterval(this.gameCountdown);
    }
    if (this.inactivityCountdown) {
      clearInterval(this.inactivityCountdown);
    }
    if (this.battleCircleCountdown) {
      clearInterval(this.battleCircleCountdown);
    }
    if (this.playerSynch) {
      clearInterval(this.playerSynch);
    }
    if (this.otherPlayerSynch) {
      clearInterval(this.otherPlayerSynch);
    }
  }

  refresh() {
    window.location.reload();
  }

  mapClicked(event) {
    if (
      this.gameService.interimSettings.mapTapActive ||
      this.pageConfig.showcaseIsActive
    ) {
      if (event.lngLat) {
        this.geoService.isQuestionNearby(
          this.gameService.activeGame.quests,
          {
            lat: event.lngLat.lat,
            lng: event.lngLat.lng,
          },
          this.activePerks
        );
        this.gameService.me.position = {
          lat: event.lngLat.lat,
          lng: event.lngLat.lng,
        };
      }
    }
  }

  mins() {
    //this.pageConfig.remainingMinutes--;
    this.gameService.activeGame.tourId.length--;
  }

  shouldFitBounds(): boolean {
    if (!this.gameService.activeGame) return false;
    
    const isEventHallGame = this.isEventHallGame();
    const isQRGame = this.gameService.activeGame.tourId.isQR;
    
    // Fit bounds for isQR games OR for non-isQR and non-event-hall games
    return isQRGame || (!isQRGame && !isEventHallGame);
  }

  onMapLoad(mapEvent) {
    this.map = mapEvent;

    // Immediate focus after map loads:
    // - Event Hall -> raster
    // - Outdoor/Indoor -> marker bounds
    setTimeout(() => {
      if (this.isEventHallGame()) {
        this.focusMapOnRaster();
      } else {
        this.focusMapOnMarkers();
      }
    }, 0);
  }

scrollToContainer(id, player) {
    document.getElementById(id).scrollIntoView({
      behavior: 'smooth',
    });
    if (player.position && player.position.lng && player.position.lat) {
      this.pageConfig.center = [player.position.lng, player.position.lat];
      this.pageConfig.zoom = [18];
    }

    setTimeout((x) => {
      this.locateMe();
    }, 5000);
  }

  getLocationConstantly() {
    const options = {
      maximumAge: 3000,
      timeout: 5000,
      enableHighAccuracy: true,
    };
    if (this.geoLocationWatch) {
      navigator.geolocation.clearWatch(this.geoLocationWatch);
    }

    // Check if location should only be accessible by clicking (isQR or event hall game)
    const isEventHallGame = this.gameService.activeGame?.tourId?._id === '695bf6db9933ee260e525657';
    const isQRGame = this.gameService.activeGame?.tourId?.isQR;
    const shouldDisableGPS = isQRGame || isEventHallGame;
    
    // If GPS should be disabled, don't start watching position
    if (shouldDisableGPS) {
      return;
    }

    this.geoLocationWatch = navigator.geolocation.watchPosition(
      (object) => {
        if (!this.notPositioned && this.map) {
          this.notPositioned = true;
          this.map.flyTo({
            center: [object.coords.longitude, object.coords.latitude],
            duration: 0,
          });
        }
        if (
          !this.gameService.interimSettings.mapTapActive &&
          !this.pageConfig.showcaseIsActive
        ) {
          this.loaders.getPosition = true;
          this.gameService.me.position = {
            lat: object.coords.latitude,
            lng: object.coords.longitude,
          };

          if (this.geoService.canLookup) {
            this.geoService.isQuestionNearby(
              this.gameService.activeGame.quests,
              {
                lat: object.coords.latitude,
                lng: object.coords.longitude,
              },
              this.activePerks
            );
            //this.ping();
          }

          //this.geoService.updateUser();

          this.loaders.getPosition = false;
        }
      },
      (error) => {
        this.loaders.getPosition = false;
        if (error && error.code === 1) {
          this.locationService.dropError();
        } else if (error && error.code === 3) {
          this.dropNoty(
            'error',
            this.localeService.getTrans(
              'Getting location data takes more time than usual. Please wait for the map to initialize'
            ),
            null,
            5000
          );
          this.getLocationConstantly();
        }
      },
      options
    );
  }

  getLocation() {
    // Check if location should only be accessible by clicking (isQR or event hall game)
    const isEventHallGame = this.gameService.activeGame?.tourId?._id === '695bf6db9933ee260e525657';
    const isQRGame = this.gameService.activeGame?.tourId?.isQR;
    const shouldDisableGPS = isQRGame || isEventHallGame;
    
    // If GPS should be disabled, don't get location
    if (shouldDisableGPS) {
      return;
    }
    
    this.pageConfig.lastPositionRefresh = moment();
    this.loaders.getPosition = true;
    this.locationService.getPosition().then(
      (x: any) => {
        this.ngZone.run(() => {
          this.dropNoty(
            'success',
            this.localeService.getTrans('Position updated!')
          );

          this.gameService.me.position = {
            lat: x.coords.latitude,
            lng: x.coords.longitude,
          };
          this.geoService.isQuestionNearby(
            this.gameService.activeGame.quests,
            {
              lat: x.coords.latitude,
              lng: x.coords.longitude,
            },
            this.activePerks
          );
          this.pageConfig.center = [x.coords.longitude, x.coords.latitude];

          if (this.map.getZoom() < this.pageConfig.zoom) {
            this.pageConfig.zoom = [15];
          }

          this.geoService.updateUser();
          this.loaders.getPosition = false;
        });
      },
      (err) => {
        this.ngZone.run(() => {
          this.loaders.getPosition = false;
          this.locationService.dropError();
        });
      }
    );
  }

  colorize() {
    if (
      this.gameService.activeGame &&
      this.gameService.activeGame.partner.color
    ) {
      let elems = document.querySelectorAll('.fi-map-control');
      Array.prototype.forEach.call(elems, (el) => {
        el.style.backgroundColor = this.bgColor1;
        el.style.borderColor = this.bgColor1;
      });
      elems = document.querySelectorAll('.flinkint-btn.primary');
      Array.prototype.forEach.call(elems, (el) => {
        el.style.backgroundColor = this.bgColor1;
        el.style.borderColor = this.bgColor1;
      });
      elems = document.querySelectorAll('.fi-game-card');
      Array.prototype.forEach.call(elems, (el) => {
        el.style.backgroundColor = this.bgColor1;
      });
    }
  }

  initGame() {
    setTimeout(() => {
      if (this.gameService.activeGame.tourId.isBattleCircle) {
        this.drawCircle(true);
      }
    }, 3000);
  }

  refreshCircle() {
    // Todo calculate
    //3/90
  }

  terminateGameDueInactivity() {
    this.inactivityCountdown = setInterval(() => {
      const endTime = moment.duration(
        moment().diff(this.gameService.activeGame.startedDate)
      );

      if (endTime.asHours() > 12) {
        this.router.navigate([
          '/endGame',
          {
            c: 'timeout',
            g: this.route.snapshot.paramMap.get('g'),
            p: this.route.snapshot.paramMap.get('p'),
            groupId: this.gameService.activeGame.groupId,
          },
        ]);
      }
    }, 5000);
  }

  detectNotification(elapsedMinutes: number){
    if(this.gameService.activeGame.tourId.notifications?.length){
    const notification = _.find(this.gameService.activeGame.tourId.notifications, (n)=>{
      return n.minutes === elapsedMinutes;
    });
   
      if(notification && this.passedNotifications.indexOf(notification) === -1){
        this.dropNoty('info', notification.title + ' | ' + notification.description);
        this.passedNotifications.push(notification);
        this.messageHistory.push({
         time: moment().format('HH:mm'),
         message: {
          adminMessage: notification.description
         }
        });
      }
    }
      
  }

  detectTimedQuestion(elapsedMinutes: number) {
    if (this.gameService.activeGame.tourId.quests.filter((quest) => quest.isTimedQuestion).length) {
      const timedQuestion = _.find(
        this.gameService.activeGame.tourId.quests.filter((quest) => quest.isTimedQuestion),
        (n) => n.timeLimit === elapsedMinutes
      );
  
      if (timedQuestion && this.passedTimedQuestion.indexOf(timedQuestion) === -1) {
        const checkAndExecute = () => {
          if (this.geoService.modalActive) {
            return; // Exit and wait for the next interval
          }
  
          // If modalActive is false, perform the action and clear the interval
          clearInterval(retryInterval);
          this.geoService.questionDetected(timedQuestion, null, this.activePerks);
        };
  
        // Start retrying every 10 seconds
        const retryInterval = setInterval(checkAndExecute, 10000);
  
        // Run the check immediately before the first interval
        checkAndExecute();
      }
    }
  }
  

  startGameCountdown() {
    this.gameCountdown = setInterval(() => {
      this.compareTimeDifference();
    }, 1000);
    if (
      this.gameService.activeGame &&
      this.gameService.activeGame.tourId.isStory &&
      this.gameService.activeGame.tourId.isBattleCircle
    ) {
      this.battleCircleCountdown = setInterval(() => {
        this.drawCircle();
      }, 5000);
    }
  }

  clearIntervals() {
    const interval_id = window.setInterval(function () {},
    Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }


  compareTimeDifference() {
    const endTime = moment(this.gameService.activeGame.startedDate).add(
      this.gameService.activeGame.tourId.length,
      'minutes'
    );

    const startTime = moment(this.gameService.activeGame.startedDate);
    const currentTime = moment();  // Get the current time
    const elapsedMinutes = currentTime.diff(startTime, 'minutes');

    console.log(this.gameService.activeGame.startedDate);
    console.log('elapsedMinutes', elapsedMinutes);

    this.detectNotification(elapsedMinutes);
    this.detectTimedQuestion(elapsedMinutes);

    if (!this.pageConfig.initialQuestion) {
      let qu = {
        question: this.localeService.getTrans('What is the goal of the game?'),
        type: '0',
        answers: [
          {
            _id: {
              $oid: 'ab1',
            },
            isTrue: true,
            answer: this.localeService.getTrans(
              'To collect all the story points'
            ),
          },
          {
            _id: {
              $oid: 'ab2',
            },
            isTrue: false,
            answer: this.localeService.getTrans('To wait until the time is up'),
          },
          {
            _id: {
              $oid: 'ab3',
            },
            isTrue: false,
            answer: this.localeService.getTrans(
              'To stay outside the battle circle'
            ),
          },
        ],
        time: 60,
        mediaUrl: null,
        _id: 'qmb123',
        points: 200,
      };
      if (this.gameService.me.passedQuests.indexOf(qu._id) === -1) {
        this.pageConfig.initialQuestion = true;
        this.geoService.questionDetected(qu, null, this.activePerks);
      } else {
        this.pageConfig.initialQuestion = true;
      }
    }

    this.pageConfig.remainingMinutes = Math.floor(
      moment.duration(endTime.diff(moment())).asMinutes()
    );

    /* if((Math.floor(moment.duration(this.pageConfig.lastPositionRefresh.diff(moment())).asSeconds())) < -60){
      this.pageConfig.lastPositionRefresh = moment();
      const element = document.querySelector('.animatebutton');
      element.classList.add('animated', 'swing');
      setTimeout(function() {
        element.classList.remove('swing');
      }, 1000);
      this.dropNoty('success', this.localeService.getTrans("Don't forget to use the 'Refresh my position' button regularly to refresh your current location in the game."))
    } */

    if (
      (this.pageConfig.remainingMinutes === 5 ||
        this.pageConfig.remainingMinutes === 10 ||
        this.pageConfig.remainingMinutes === 15) &&
      this.pageConfig.remainingSentSlots !== this.pageConfig.remainingMinutes
    ) {
      this.dropNoty(
        'info',
        this.localeService.getTrans('Hurry up, only ') +
          this.pageConfig.remainingMinutes +
          this.localeService.getTrans(' minutes left!')
      );
      this.pageConfig.remainingSentSlots = this.pageConfig.remainingMinutes;
    }

    if (this.pageConfig.remainingMinutes <= 0) {
      this.clearIntervals();
      navigator.geolocation.clearWatch(this.geoLocationWatch);
      this.geoService.endGame('timeout');
      //this.router.navigate(['/endGame', { c: 'timeout', g: this.route.snapshot.paramMap.get('g'), p: this.route.snapshot.paramMap.get('p') }]);
    }
  }

  dropPointInfoNoty(point) {
    if(point){
      this.dropNoty(
        'info',
        this.localeService.getTrans('This question will earn you') +
          ' ' +
          point + this.localeService.getTrans(' points if your answer is correct.')
      );
    }
    
  }

  dropNoty(type, text, clickEvent?, timeout?) {
    new Noty({
      type: type,
      text: text,
      killer: true,
      timeout,
      callbacks: {
        onClick: () => {
          if (clickEvent && clickEvent === 'safehouse') {
            this.pageConfig.center = [
              this.gameService.endQuest.coordinates[0],
              this.gameService.endQuest.coordinates[1],
            ];
            this.pageConfig.zoom = [22];
          } else{
            console.log('scrollDown')
            const element = document.querySelector("#message_history");
            if(element){
              element.scrollIntoView({ behavior: 'smooth', block: 'end'});
            }
          }
        },
      },
    }).show();
  }

  
  dropTooltip(image, title, text) {
  
    Swal.fire({
      imageUrl: image,
      title,
      text,
      showDenyButton: false,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`Got it`),
      confirmButtonColor: this.bgColor1,
      cancelButtonText: 'Back',
    });
  }
  clickedBackpack(item) {
    Swal.fire({
      imageUrl: item,
      title: this.localeService.getTrans('Backpack item'),
      text: this.localeService.getTrans(
        'This item may help you to solve the final riddle.'
      ),
      showDenyButton: false,
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`Got it`),
      confirmButtonColor: this.bgColor1,
      cancelButtonText: this.localeService.getTrans('Back'),
    });

    //this.dropNoty('info','This item will be useful and the end of the game.')
  }
  refreshPosition() {}

  showPlayerInfo(player) {
    Swal.fire({
      imageUrl: this.emojiService
        .getEmojiByIndex(player.avatarIndex)
        .icon.toString(),
      title: player.name,
      confirmButtonColor: this.gameService.activeGame.partner
        ? this.gameService.activeGame.partner.color
        : null,
      text:
        player.name +
        this.localeService.getTrans(
          ' is a fellow player in the musesum who scored '
        ) +
        player.points +
        this.localeService.getTrans(' points so far.') +
        (!player.isFinished
          ? this.localeService.getTrans(' The player is still in the museum!')
          : ''),
      confirmButtonText: this.localeService.getTrans(`Got it`),
    });
  }

  checkMapTapPerk(users) {
    const otherPlayers = _.filter(users, (user) => {
      return user.name === this.pageConfig.playerId;
    });
    const perkEvents = _.orderBy(
      _.flatten(
        _.map(otherPlayers, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return perkEvent.type === 'map_tap';
          });
        })
      ),
      ['created'],
      ['desc']
    );

    if (perkEvents.length > 0) {
      let tm = moment.unix(perkEvents[0].created);

      if (Math.floor(moment.duration(tm.diff(moment())).asSeconds()) > -35) {
        this.gameService.interimSettings.mapTapActive = true;
      } else {
        this.gameService.interimSettings.mapTapActive = false;
      }
    }
  }

  checkFreezePerk(users) {
    const otherPlayers = _.filter(users, (user) => {
      return !user.isMe;
    });
    const perkEvents = _.orderBy(
      _.flatten(
        _.map(otherPlayers, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return perkEvent.type === 'freeze';
          });
        })
      ),
      ['created'],
      ['desc']
    );

    if (perkEvents.length > 0) {
      let tm = moment.unix(perkEvents[0].created);

      if (Math.floor(moment.duration(tm.diff(moment())).asSeconds()) > -35) {
        this.gameService.interimSettings.freezeActive = true;
      } else {
        this.gameService.interimSettings.freezeActive = false;
      }
    }
  }

  checkBombPerk(users) {
    const bombEvent = _.orderBy(
      _.flatten(
        _.map(users, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return (
              perkEvent.type === 'bomb' &&
              perkEvent.target === this.gameService.me.name &&
              perkEvent.isActive === true
            );
          });
        })
      ),
      ['created'],
      ['desc']
    );
    if (bombEvent.length) {
      this.activePerks.bomb = true;
      this.createdBombPerkBy = bombEvent[0].createdBy;
    }
  }

  checkBlankMapPerk(users) {
    const otherPlayers = _.filter(users, (user) => {
      return !user.isMe;
    });
    const perkEvents = _.orderBy(
      _.flatten(
        _.map(otherPlayers, (player) => {
          return _.filter(player.perkEvents, (perkEvent) => {
            return perkEvent.type === 'blank_map';
          });
        })
      ),
      ['created'],
      ['desc']
    );

    if (perkEvents.length > 0) {
      let tm = moment.unix(perkEvents[0].created);

      if (Math.floor(moment.duration(tm.diff(moment())).asSeconds()) > -35) {
        // this.mapStyle =
        //   'mapbox://styles/ercseypeter1/cl7hh0afu002m14qg80cjrff1';
        this.activePerks.blank_map = true;
      } else {
        //this.mapStyle = this.gameService.activeGame.tourId.style.mapStyle;
        this.activePerks.blank_map = false;
      }
    }
  }

  countPerks(type, points) {
    let perkEvents = _.filter(this.gameService.me?.perkEvents, (perkEvent) => {
      return perkEvent.type === type;
    });
    return perkEvents.length > 0 ? 1 : 1;
  } 

  synchOtherPlayers() {
    return this.http
      .post(environment.baseUrl + 'games/getOtherPlayers', {
        groupId: this.gameService.activeGame.groupId,
        playerId: this.gameService.me ? this.gameService.me._id : null,
        isDigitalMuseum: this.gameService.activeGame.partner
          ? this.gameService.activeGame.partner.isDigitalMuseum
          : null,
        partnerId: this.gameService.activeGame.partner
          ? this.gameService.activeGame.partner._id
          : null,
        tourId: this.gameService.activeGame.tourId._id,
      })
      .subscribe((data: any) => {
        _.remove(data.data, (d) => {
          return !d;
        });
        this.museumPlayers = _.orderBy(data.data, ['points'], ['desc']);
        
        // Add fake users if virtual mode is active
        if (this.pageConfig.virtualModeActive && this.fakeUsers.length > 0) {
          this.museumPlayers.push(...this.fakeUsers);
          this.museumPlayers = _.orderBy(this.museumPlayers, ['points'], ['desc']);
        }
  
        if (data.success) {
          _.remove(data.data, (x) => {
            return !x;
          });
  
          const me = _.find(data.data, (x) => {
            return x.name === this.pageConfig.playerId;
          });
  
          if (me && me.points && this.gameService.me.points !== me.points) {
            this.gameService.me.points = me.points;
          }
  
          // Iterate through all players' photos to check for validation

            if (me.photos && me.photos.length > 0) {
              const autoImageProcessing = this.gameService.activeGame.tourId.isAutoImageProcessing;
              let assignedImages = 0; // Counter for how many images have been assigned points

              console.log(autoImageProcessing, 'autoImageProcessing');
              me.photos.forEach((photo) => {
                
                if (photo.points !== null && photo.points !== undefined) {
                  const storedPhotoUrls = JSON.parse(localStorage.getItem('validatedPhotoUrls-'+this.gameService.me._id)) || [];
                  console.log('Stored photo URL checks:', storedPhotoUrls);
                  // Check if this photo URL has already been processed
                  if (!storedPhotoUrls.includes(photo.url)) {
                    console.log('its not stored')
                      // Drop a SweetAlert notification
                      this.dropValidatedImageNoty(photo);

                    // Store the URL in localStorage to avoid duplicate notifications
                    storedPhotoUrls.push(photo.url);
                    localStorage.setItem('validatedPhotoUrls-'+this.gameService.me._id, JSON.stringify(storedPhotoUrls));
                  }
                } else{
                  const storedPhotoUrls = JSON.parse(localStorage.getItem('validatedPhotoUrls-'+this.gameService.me._id)) || [];
                
                  // Check if this photo URL has already been processed
                  if (!storedPhotoUrls.includes(photo.url)) {
                   

                    if(autoImageProcessing && storedPhotoUrls.length < this.gameService.activeGame.tourId.autoImageProcessing.numberOfImages){
                      this.geoService.validateImage(this.gameService.activeGame.tourId.autoImageProcessing.points, photo.url);
                      
                      this.dropValidatedImageNoty({...photo, ...{
                        points: this.gameService.activeGame.tourId.autoImageProcessing.points
                      }});
                          // Store the URL in localStorage to avoid duplicate notifications
                    storedPhotoUrls.push(photo.url);
                    localStorage.setItem('validatedPhotoUrls-'+this.gameService.me._id, JSON.stringify(storedPhotoUrls));
                    } 
                
                }
              }
              });
            }
      
  
          _.remove(data.data, (x) => {
            return x.name === this.pageConfig.playerId;
          });
  
          const mapPlayers = _.cloneDeep(
            _.filter(data.data, (d) => {
              return !d.isFinished;
            })
          );
          
          // Add fake users if virtual mode is active (filter out any existing fake users first)
          if (this.pageConfig.virtualModeActive && this.fakeUsers.length > 0) {
            const realPlayers = mapPlayers.filter(p => !p.isFake);
            mapPlayers.length = 0;
            mapPlayers.push(...realPlayers, ...this.fakeUsers);
          }
          
          // Sort by points and take top 10 for enemy markers
          const sortedPlayers = _.orderBy(mapPlayers, ['points'], ['desc']);
          this.gameService.enemyMarkers = sortedPlayers.slice(0, 10);
          this.gameService.mapPlayers = mapPlayers;
          
          this.gameService.me.ranking = _.findIndex(
            _.orderBy(this.gameService.mapPlayers, ['points'], ['desc']),
            (r) => {
              return r.name === this.pageConfig.playerId;
            }
          );
          
          this.checkFreezePerk(data.data);
          this.checkMapTapPerk(this.museumPlayers);
          this.checkBlankMapPerk(data.data);
          this.checkBombPerk(data.data);
        }
      });
  }

  dropValidatedImageNoty(photo) {

    if(photo && photo.points){
      Swal.fire({
        title: this.localeService.getTrans('Photo Validated!'),
        text: this.localeService.getTrans('Your photo has been validated and you earned ') + photo.points + this.localeService.getTrans(' points.'),
        imageUrl: photo.url,
        imageAlt: 'Validated Photo'
      });
    } else{
      Swal.fire({
        title: this.localeService.getTrans('Photo Not Accepted'),
        text: this.localeService.getTrans('Unfortunately, we could not accept your photo.'),
        imageUrl: photo.url,
        imageAlt: 'Rejected Photo',
        icon: 'error'
      });
    }
  }


  initPubnub() {
    let id = _.find(this.gameService.activeGame.players, (p) => {
      return p.name.toLowerCase() === this.route.snapshot.paramMap.get('p').toLocaleLowerCase();
    });
    this.gameService.me = id;
    this.geoService.checkUserHasPaid(this.gameService.me);
    console.log('ITS ME', this.gameService.me);

    this.pubnub = new PubNub({
      publishKey: "pub-c-19cd6237-8998-4fcb-a001-a33dc293184f", //"pub-c-125b7199-434c-4139-8b37-3a36487c543d",
      subscribeKey: "sub-c-8b99f907-737b-40f5-bafd-ae82ab4cd196", //"sub-c-e07e43ee-5694-11eb-bf6e-f20b4949e6d2",
      uuid: id._id,
    });

    this.subscribeForPubnub();
  }

  getPubnubHistory() {
    this.pubnub.fetchMessages(
      {
        channels: [this.gameService.activeGame.groupId],
        count: 100,
      },
      (status, response) => {
        if (
          response &&
          response.channels &&
          response.channels &&
          response.channels[this.gameService.activeGame.groupId]
        ) {
          this.messageHistory = _.map(
            response.channels[this.gameService.activeGame.groupId],
            (f) => {
              return {
                ...f,
                ...{ time: moment.unix(f.timetoken / 10000000).fromNow() },
              };
            }
          );
          this.reorderMessageHistory();
        }
      }
    );
  }

  subscribeForPubnub() {
    this.pubnub.addListener({
      message: (msg) => {
        this.updatePlayerAll(msg);
      },
    });
    this.pubnub.subscribe({
      channels: [this.gameService.activeGame.groupId],
    });
    this.getPubnubHistory();

    //this.ping();
  }

  reorderMessageHistory() {
    this.messageHistory = _.orderBy(
      this.messageHistory,
      ['timetoken'],
      ['desc']
    );
  }

  touchMap() {
    this.geoService.mapTouched = true;
  }

  updatePlayerAll(msg) {
    if (msg.message.adminMessage) {
      this.dropNoty('info', 'Admin: ' + msg.message.adminMessage);
      this.messageHistory.push({
        ...msg,
        ...{ time: moment.unix(msg.timetoken / 10000000).fromNow() },
      });
      this.reorderMessageHistory();
      this.geoService.vibrate();
    }

    /*   if(msg.message.player !== ('admin-' + this.gameService.activeGame._id)){
      this.gameService.activeGame.players.splice(_.findIndex(this.gameService.activeGame.players, {_id: msg.message.player}), 1, msg.message.payload);
      this.gameService.mapPlayers = _.filter(_.cloneDeep(this.gameService.activeGame.players), (y)=>{
        return y._id !== this.gameService.me._id;
      });
  
      if(msg.message.perks && msg.message.perks.length){      
        if(msg.message.perks[0] && msg.message.perks[0].created && msg.message.perks[0].creator !== this.route.snapshot.paramMap.get('p')){
          let tm = moment(msg.message.perks[0].created);
          if(msg.message.perks[0].name === 'freeze' && Math.floor(moment.duration(tm.diff(moment())).asSeconds())>-30){
            this.gameService.interimSettings.freezeActive = true;
          } else{
            this.gameService.interimSettings.freezeActive = false;
          }
        }
      }
  
      if(msg.message.type){
        if(msg.message.type === 1){
          this.geoService.endGame('direct')
          //this.endGame('direct');
        }
  
      }
  
      this.geoService.calculateRanking();
      this.cd.markForCheck();
    } else{
      if(msg.message.adminMessage){
        this.dropNoty('info', 'Admin: ' + msg.message.adminMessage);
      }
    } */
  }

  getRankingMapPlayers() {
    let players = this.museumPlayers;
    
    // Add fake users if virtual mode is active
    if (this.pageConfig.virtualModeActive && this.fakeUsers.length > 0) {
      const realPlayers = players.filter(p => !p.isFake);
      players = [...realPlayers, ...this.fakeUsers];
    }
    
    return _.orderBy(
      players,
      [
        (o) => {
          return o.points;
        },
      ],
      ['desc']
    );
  }
  getRanking() {
    return _.orderBy(
      this.gameService.activeGame.players,
      [
        (o) => {
          return o.points;
        },
      ],
      ['desc']
    );
  }

  ping(type?) {
    let publishPayload = {
      channel: this.gameService.activeGame._id,
      message: {
        player: this.gameService.me._id,
        position: this.gameService.me.position,
        points: this.gameService.me.points,
        payload: this.gameService.me,
        perks: this.gameService.activeGame.teamPerks,
        type: type,
      },
    };
    if (this.pubnub) {
      this.pubnub.publish(publishPayload);
    }
  }

  synchPlayers() {
    this.initPubnub();
    if (!this.gameService.activeGame.tourId.isQR) {
      this.getLocationConstantly();
    }

    /*  return this.http.post(environment.baseUrl + 'games/getPlayers', {gameId: this.gameService.activeGame._id} ).subscribe((data: any) => {
      
       if(data.success){
         this.gameService.activeGame.players = data.data.players;
         this.gameService.mapPlayers = _.cloneDeep(data.data.players);
 
         
         let me = _.find(this.gameService.activeGame.players, (x) => {
             return (x.name === this.pageConfig.playerId);
         });
       
       
         this.perks = _.map(this.perks, (p)=>{
          
           return _.merge(p, {
             point: p.defaultPoint+(me.perkCounter*100)
           })
           
         })
 
         this.gameService.activeGame.quests = _.filter(this.gameService.activeGame.quests, (q)=>{
           return me.passedQuests.indexOf(q._id) === -1
         }) 
 
         // TODO (calculate that all players collected team points)
         // this.isTeamQuestSuccessful();
        
         _.remove(this.gameService.mapPlayers, (x) => {
           return (x.name === this.pageConfig.playerId);
         });
 
       
         // Igazából innentől kéne beépíteni
 
         if(!_.find(this.gameService.activeGame.quests, (q)=>{
           return q.questionType === 'story'
         })){
           if(!this.gameService.isPartnerGame){
             this.activateGameEndPOI();
           } else{
             if(_.filter(this.gameService.activeGame.quests, (quest)=>{return quest.isQuestion}).length === 0){
               this.endGame('end');
             }
           }
          f
         }
 
         if(_.filter(this.gameService.activeGame.quests, (quest)=>{return quest.isQuestion}).length === 0){
           this.endGame('end');
         }
 
          if((this.gameService.me.passedQuests.length <= me.passedQuests.length)){
           this.gameService.me = me;
         } 
        
         this.museumPlayers = _.orderBy(_.merge(this.museumPlayers, this.gameService.me), ['points'],['desc']);
        
         if(data.data.teamPerks && data.data.teamPerks.length){
         
           if(data.data.teamPerks[0] && data.data.teamPerks[0].created && data.data.teamPerks[0].creator !== this.route.snapshot.paramMap.get('p')){
             let tm = moment(data.data.teamPerks[0].created);
           
             if(data.data.teamPerks[0].name === 'freeze' && Math.floor(moment.duration(tm.diff(moment())).asSeconds())>-30){
               this.gameService.interimSettings.freezeActive = true;
             } else{
               this.gameService.interimSettings.freezeActive = false;
             }
           }
         
         }
 
         if(me.isFinished || this.gameService.activeGame.isFinished){
           this.endGame('endPoi');
         }
         this.gameService.me.ranking = _.findIndex(_.orderBy(this.gameService.activeGame.players, ['points'], ['desc']), (r)=>{
           return (r.name === this.pageConfig.playerId);
         })
 
         if(isInit){
          
 
           if(this.gameService.activeGame.indoorMode){
             this.initIndoorMode(this.gameService.activeGame.quests[0]);
           } else if(!this.gameService.activeGame.tourId.isQR){
 
             this.getLocationConstantly();
             //this.getLocation();
 
           }
              
         }
       } 
     });  */
  }
  isTeamQuestSuccessful() {}

  uploadImage() {
    this.modalService.dismissAll();

    this.isImageUploading = true;

    if (!this.previewImage.type.startsWith('image/')) {
      alert('Please upload a valid image.');
      return;
    }

 /*    if(this.currentCard){
      this.currentCard.isDisabled = true;
    } */
    
    const formData = new FormData();
    formData.append('file', this.previewImage);

    return this.http
      .post(environment.baseUrl + 'file-service/upload', formData)
      .subscribe((data: any) => {
        this.updateUserWithImageAndLocation(data.url);
        this.isImageUploading = false;
        this.dropNoty(
          'success',
          this.localeService.getTrans('Image successfully uploaded')
        );
        this.audioService.play('success');
      }, (err)=>{
        this.dropNoty(
          'error',
          this.localeService.getTrans('Image upload failed. Maybe it is a problem with the file size. Please try again with selecting a file from your gallery or take a new photo using your front camera.')
        )
        this.isImageUploading = false;
      });
  }

  uploadImages(event) {
    const files = (event.target as HTMLInputElement).files;
    this.previewImage = files[0];
    

    const reader = new FileReader();
    reader.readAsDataURL(this.previewImage);
    reader.onload = () => {
      const image: any = new Image();
      image.src = reader.result;
      this.dynamic_url = image.src;
    };
  }

  async updateUserWithImageAndLocation(fileUrl) {
    return this.http
      .post(environment.baseUrl + 'games/updateUserWithImageAndLocation', {
        fileUrl,
        isCardContent: this.currentCardObj ? true : false,
        text: this.currentCardObj ? this.currentCardObj.title : this.imageComment,
        user: this.gameService?.me,
      })
      .subscribe((data: any) => {
        this.imageComment = null;

        if(this.currentCardObj){
         
          this.showNextCard();
          this.geoService.getUserByMe(this.route.snapshot.paramMap.get('p'));
          setTimeout(() => {
           this.getGameNotes();
          },1000);
          
        }


        this.dropNoty(
          'info',
          this.localeService.getTrans('Image successfully uploaded')
        );
      });
  }

  triggerDropCamcorder(currentCardObj?: any){
    if(this.currentCard.isDisabled || !this.isNotesImageCheck || this.isImageUploading){
      return;
    }
    
    this.dropCamcorder(currentCardObj);

  }

  dropCamcorder(currentCardObj?: any) {

    this.imageMessage = null;
    this.currentCardObj = currentCardObj || null;
  
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    //input.capture = 'environment'; // force camera on iOS
    input.style.display = 'none';

    console.log('Input created:', input);
  
    // Append to body to ensure it works on all browsers
    document.body.appendChild(input);
  
    input.addEventListener('change', (event: any) => {
      const files = (event.target as HTMLInputElement).files;
      console.log('Input change triggered', files);
  
      if (files && files.length > 0) {
        this.previewImage = files[0];
        console.log('Selected image:', this.previewImage);
  
        const reader = new FileReader();
  
        reader.onerror = (err) => {
          console.error('FileReader error', err);
          this.dropNoty('error', 'Image read failed.');
        };
  
        reader.onload = () => {
          console.log('FileReader onload triggered');
          setTimeout(() => {
            this.ngZone.run(() => {
              const result = reader.result as string;
              if (result && result.startsWith('data:image')) {
                this.dynamic_url = result;
                console.log('Opening camcorder modal');
                this.modalService.dismissAll();
                this.modalService.open(this.camCorderModal, { centered: true });
              } else {
                console.warn('Invalid image data:', result);
                this.dropNoty('error', 'Could not load image. Try again.');
              }
            });
          }, 800); // iOS needs extra time
        };
  
        reader.readAsDataURL(this.previewImage);
      } else {
        console.warn('No files selected');
      }
  
      // Cleanup
      input.remove();
    });
  
    input.click();
  }
  

  togglePerk(content, perk) {
    if (this.gameService.me.points < perk.points) {
      this.dropNoty(
        'info',
        this.localeService.getTrans(
          "You don't have enough points to use this perk."
        )
      );
    } else {
      let selectedPerk = perk;
      Swal.fire({
        imageUrl: './assets/images/v3/' + perk.type + '.svg',

        title: this.getPerkModalLocale(selectedPerk.type).title,
        text: this.getPerkModalLocale(selectedPerk.type).text,
        showDenyButton: false,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: this.localeService.getTrans(`Use perk`),
        confirmButtonColor: this.bgColor1,
        cancelButtonText: this.localeService.getTrans('Back'),
      }).then((result) => {
        if (result.isConfirmed) {
          if (selectedPerk.type === 'photo') {
            console.log('photo');
            this.previewImage = null;
            this.dynamic_url = null;
            this.dropCamcorder();
          } else {
            if (selectedPerk.type === 'freeze') {
              this.dropNoty(
                'info',
                this.getPerkModalLocale(selectedPerk.type).info
              );
              let players = _.filter(this.museumPlayers, (player) => {
                return player.name !== this.gameService.me.name;
              });
              if (!players.length) {
                this.dropNoty(
                  'info',
                  this.localeService.getTrans(
                    'No other players to use this perk on.'
                  )
                );
                return false;
              }
            } else if (selectedPerk.type === 'bomb') {
              let players = _.filter(this.museumPlayers, (player) => {
                return player.name !== this.gameService.me.name;
              });
              if (players.length) {
                selectedPerk.target =
                  players[Math.floor(Math.random() * players.length)].name;
                this.dropNoty(
                  'info',
                  this.getPerkModalLocale(selectedPerk.type).info
                );
              } else {
                this.dropNoty(
                  'info',
                  this.localeService.getTrans(
                    'No other players to use this perk on.'
                  )
                );
                return false;
              }
            } else if (selectedPerk.type === 'blank_map') {
              let players = _.filter(this.museumPlayers, (player) => {
                return player.name !== this.gameService.me.name;
              });
              if (!players.length) {
                this.dropNoty(
                  'info',
                  this.localeService.getTrans(
                    'No other players to use this perk on.'
                  )
                );
                return false;
              } else{
                this.dropNoty('info', this.localeService.getTrans('Splashed egg perk is active for 30 seconds.'));
              }
            } else if (selectedPerk.type === 'map_tap') {
              this.dropNoty(
                'info',
                this.getPerkModalLocale(selectedPerk.type).info
              );
            } else if (selectedPerk.type === 'text_input') {
              this.modalService.open(this.textInputModal, { centered: true });
            }
            return this.http
              .post(environment.baseUrl + 'games/usePerk', {
                u: this.gameService.me._id,
                perk: selectedPerk,
                t: moment().unix(),
              })
              .subscribe((data: any) => {
                this.gameService.me = data;
              });
          }
        }
      });
    }
  }

  getPerkModalLocale(type) {
    let locales = {
      freeze: {
        title: this.localeService.getTrans('Freeze'),
        text: this.localeService.getTrans(
          'You can freeze all players for 30 seconds'
        ),
        info: this.localeService.getTrans(
          'Freeze perk is active. You frozed all other players for 30 seconds.'
        ),
      },
      blank_map: {
        title: this.localeService.getTrans('Splashed egg'),
        text: this.localeService.getTrans(
          'A splashed egg is displayed to players, obscuring the map for 30 seconds.'
        ),
        info: this.localeService.getTrans(
          'Splashed egg perk is active for 30 seconds.'
        ),
      },
      photo: {
        title: this.localeService.getTrans('Photo gallery'),
        text: this.localeService.getTrans(
          'You can take photos during the game.'
        ),
        info: this.localeService.getTrans('You just activated the photo perk.'),
      },
      bomb: {
        title: this.localeService.getTrans('Bomb'),
        text: this.localeService.getTrans(
          'You can throw a bomb on a random player.'
        ),
        info: this.localeService.getTrans('You just activated the bomb perk.'),
      },
      map_tap: {
        title: this.localeService.getTrans('Map tap'),
        text: this.localeService.getTrans(
          'Simulate your position by tapping on the map.'
        ),
        info: this.localeService.getTrans(
          'Tap on the map to simulate your position and reach remote points for up to 30 seconds. Please wait 5 seconds after activating this perk before starting to tap.'
        ),
      },
      text_input: {
        title: this.localeService.getTrans('Text Input'),
        text: this.localeService.getTrans('Send message to Game host'), // TODO: change
        info: this.localeService.getTrans(
          'You can send message to the game master'
        ), // TODO: change
      },
    };

    return locales[type];
  }

  getPlayers() {
    this.geoService.getUserByTeamName(this.route.snapshot.paramMap.get('p'));
    /*   this.playerSynch = setInterval(() => {
      this.synchPlayers();
    }, 8000); */
    this.synchOtherPlayers();
    this.otherPlayerSynch = setInterval(() => {
      this.synchOtherPlayers();
      this.geoService.updateUserIfOK();
    }, 10000);

    setTimeout(() => {
      this.synchPlayers();
    }, 3000);

    /*   if(this.route.snapshot.paramMap.get('p') === 'admin-terminator'){
      this.otherPlayerSynch = setInterval(() => {
          this.geoService.updateUserStress();
          //this.ping();
      }, 1000);
    } */
  }
  removeMapComponent() {
    if (this.map) {
      this.map.destroy();
    }
  }
  endGameDirectly() {
    Swal.fire({
      title: this.localeService.getTrans('Do you really want to end the game?'),
      text: this.localeService.getTrans(
        "You cannot rejoin in the game if you hit 'End Game'"
      ),
      showDenyButton: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: this.localeService.getTrans(`End Game`),
      confirmButtonColor: this.bgColor1,
      cancelButtonText: this.localeService.getTrans('Back'),
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.geoLocationWatch) {
          navigator.geolocation.clearWatch(this.geoLocationWatch);
        }
        this.geoService.endGame('direct');
        //this.endGame('direct');
        //this.ping(1);
      }
    });
  }

  clearPhotoStorageAtEndOfGame() {
    localStorage.removeItem('validatedPhotoUrls-'+this.gameService.me._id);
  }

  endGame(reason) {
    this.clearIntervals();
    this.clearPhotoStorageAtEndOfGame();
    if (this.gameService.activeGame.isEndPOI) {
      this.doEndGame(reason);
    } else {
      this.doEndGame(reason);
    }
  }

  doEndGame(reason) {
    if (this.geoLocationWatch) {
      navigator.geolocation.clearWatch(this.geoLocationWatch);
    }
    this.clearIntervals();
    this.geoService.endGame(reason);
  }

  initIndoorMode(question) {
    this.geoService.questionDetected(question, true, this.activePerks);
  }
  toggleLevels() {
    if (
      this.activeLevel ===
      _.maxBy(this.gameService.activeGame.partner.raster_image_url, (x) => {
        return x.level;
      }).level
    ) {
      this.activeLevel = 1;
    } else {
      this.activeLevel = this.activeLevel + 1;
    }
    this.setLevels(this.activeLevel);
  }
  setLevels(level) {
    this.activeLayers = _.filter(
      this.gameService.activeGame.partner.raster_image_url,
      (x) => {
        return x.level === level;
      }
    );
  }

  scanQR() {
    // If the virtual helper overlay is visible, hide it as soon as the user starts scanning
    if (this.pageConfig?.virtualModeActive && this.pageConfig?.showLocationSimulator) {
      this.hideLocationSimulator();
    }

    // Virtual demo: don't open camera, simulate a QR scan instead
    if (this.pageConfig?.virtualModeActive) {
      Swal.fire({
        title: 'Demo mode',
        text: 'This is a demo. The camera will not pop up. Please press Confirm to simulate scanning a QR code.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        confirmButtonColor: this.bgColor1 || '#707cc0',
      }).then((res) => {
        if (res.isConfirmed) {
          this.simulateRandomRemainingQrQuestion();
        }
      });
      return;
    }

    this.pageConfig.showQrReader = true;
    this.changeDetectorRef.detectChanges();
    this.scanner.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
      this.hasDevices = true;
      this.availableDevices = devices;

      // selects the devices's back camera by default
      for (const device of devices) {
        if (/back|rear|environment/gi.test(device.label)) {
          this.scanner.isCurrentDevice(device);
          this.currentDevice = device;
          break;
        }
      }
    });

    this.scanner.camerasNotFound.subscribe(() => (this.hasDevices = false));
    this.scanner.permissionResponse.subscribe(
      (perm: boolean) => (this.hasPermission = perm)
    );
  }

  private simulateRandomRemainingQrQuestion(): void {
    const passed: string[] = (this.gameService?.me?.passedQuests || []) as any;
    const activeLevel = this.activeLevel || 1;
    const quests = (this.gameService?.activeGame?.quests || []) as any[];

    // QR games can have info POIs too; the scan should pick an actual question.
    const remaining = quests.filter((q) => {
      if (!q) return false;
      if (q.isEndPOITimeline) return false;
      if (q.level !== undefined && q.level !== null && q.level !== activeLevel) return false;
      if (!q.isQuestion) return false;
      if (!q._id) return false;
      return passed.indexOf(q._id) === -1;
    });

    // If this is a sequence + showOnlyNext game, be deterministic (simulate the next one).
    const tour = this.gameService?.activeGame?.tourId;
    const shouldShowOnlyNext = !!(tour?.isSequenceGame && tour?.isShowOnlyNextQuestion);
    const question = shouldShowOnlyNext
      ? remaining[0]
      : remaining[Math.floor(Math.random() * remaining.length)];

    if (!question) {
      Swal.fire({
        title: 'No remaining questions',
        text: 'All QR questions on this level have already been completed in this demo.',
        icon: 'warning',
        confirmButtonText: 'OK',
        confirmButtonColor: this.bgColor1 || '#707cc0',
      });
      return;
    }

    // Trigger the same path as a real QR scan result.
    this.geoService.questionDetected(question, null, this.activePerks);
  }

  


  handleQrCodeResult(resultString: string) {
    this.closeQR();

    let str = resultString.substr(
      resultString.indexOf('&qId=') + 5,
      resultString.length
    );
    str = str.split('&')[0];


    if (resultString && str) {
      let question = _.find(this.gameService.activeGame.quests, (q) => {
        return q._id == str;
      });

      if (question) {
        this.geoService.questionDetected(question, null, this.activePerks);
      } else {
        this.utilsService.dropSwal(
          this.localeService.getTrans('Uh oh'),
          this.localeService.getTrans(
            'This QR code has been activated already'
          ),
          'info',
          this.localeService.getTrans('Got it'),
        );
      }
    }
  }

  closeQR() {
    this.pageConfig.showQrReader = false;
    if (this.scanner) {
      this.scanner.scanStop();
    }
  }

  sendTextInput() {
    this.modalService.dismissAll();
    console.log(this.textInputValue, 'input');
    if (this.textInputValue) {
      this.http
        .post(environment.baseUrl + 'games/sendTextInput', {
          text: this.textInputValue,
          player: this.gameService.me,
          gameId: this.gameService.activeGame._id,
        })
        .subscribe((data: any) => {
          this.textInputValue = '';
          this.dropNoty('success', this.localeService.getTrans('Text snippet sent'));
         
        });
    }
  }

  getGameNotes(isPolling = false) {
    return this.http.post(environment.baseUrl + `games/getGameNotes`,  {groupId: this.gameService.activeGame.groupId}).subscribe((res: any) => {
      if(res.tourId && res.tourId.notes){
        if(res.notes.length !== this.gameNotes.length && this.firstGameNoteRun === false){
          this.dropNoty('info', this.localeService.getTrans('New game card available!'));
        }

        res.notes = res.notes.map((note) => {

          let isDisabled = false;

          console.log(this.gameService.me)

          if(this.gameService.me && this.gameService.me.photos){
            const photo = _.find(this.gameService.me.photos, (p) => {
              return p.isCardContent && p.text === note.title;
            });

            if(photo){
              isDisabled = true;

              if(this.currentCard && this.currentCard.title === note.title){
                this.currentCard.isDisabled = true;
              }
            }

            this.isNotesImageCheck = true;

          }

          return {
            ...note,
            ...{
             isDisabled
            }
          };
        });

        this.gameNotes = [...res.notes];
        console.log(this.gameNotes, 'game notes');
       


        if(this.firstGameNoteRun){
          this.currentCard = this.gameNotes[this.currentCardIndex];
        } 
        
        this.firstGameNoteRun = false;
        
        if(isPolling){
          setTimeout(() => {
            this.getGameNotes(isPolling);
          },10000);
        }

      }
       

    });
}

showNextCard() {
  if (this.gameNotes.length > 0 && !this.isImageUploading) {
    if(this.currentCardIndex +1 >= this.gameNotes.length){
      this.currentCardIndex = 0;
      this.currentCard = this.gameNotes[this.currentCardIndex];
    } else{
      this.currentCardIndex++;
      this.currentCard = this.gameNotes[this.currentCardIndex];
    }
   
   
  }
}

  getGame(gameId, player, isInit?) {
    return this.http
      .post(environment.baseUrl + 'games/getGame', { gameId, player })
      .subscribe((data: any) => {
        if (data.success) {
          this.gameService.activeGame = data.data;

          if(this.gameService.activeGame.isNotesEnabled){
            this.getGameNotes(true);
          }


         

       
          console.log(this.gameService.activeGame);
          
          if (data.data.isFinished) {
            this.router.navigate(['/review'])
            // this.router.navigate([
            //   '/endGame',
            //   {
            //     c: 'direct',
            //     g: this.route.snapshot.paramMap.get('g'),
            //     p: this.route.snapshot.paramMap.get('p'),
            //     groupId: this.gameService.activeGame.groupId,
            //   },
            // ]);
          } else {
            if (data.data.partner) {
              this.gameService.isPartnerGame = true;
              this.pageConfig.initialQuestion = true;
            }
          
            console.log(this.gameService.activeGame.tourId.style.mapStyle)
            this.mapStyle = this.gameService.activeGame.tourId.style.mapStyle;

            this.bgColor1 = this.gameService.activeGame.partner
              ? this.gameService.activeGame.tourId.isCustomBranding &&
                this.gameService.activeGame.tourId.customBranding.color
                ? this.gameService.activeGame.tourId.customBranding.color
                : this.gameService.activeGame.partner.color
                ? this.gameService.activeGame.partner.color
                : null
              : null;

            if (
              this.route.snapshot.paramMap.get('showcase') === 'true' &&
              this.route.snapshot.paramMap.get('showcase') !== undefined
            ) {
              this.pageConfig.showcaseIsActive = true;
            }
            
            // Check for virtual mode (from query params or matrix params)
            const urlParams = new URLSearchParams(window.location.search);
            const virtualParam = urlParams.get('virtual');
            let showcase = urlParams.get('showcase');
            if (!showcase) {
              const fullUrl = window.location.href;
              const pathPart = fullUrl.split('?')[0];
              const matrixMatch = pathPart.match(/[;]showcase=([^;?]+)/);
              if (matrixMatch) {
                showcase = matrixMatch[1];
              }
            }
            this.pageConfig.virtualModeActive = this.pageConfig.showcaseIsActive && showcase === 'true' && virtualParam !== null;
            this.pageConfig.showLocationSimulator = this.pageConfig.virtualModeActive;
            this.scheduleAutoFreezeForOutdoorDemo();
            
            // Initialize fake users if virtual mode is active (after game data is loaded)
            if (this.pageConfig.virtualModeActive && this.gameService.activeGame && this.gameService.activeGame.quests) {
              setTimeout(() => {
                this.initializeFakeUsers();
              }, 500); // Small delay to ensure game data is fully loaded
            }

            this.localeService.locale = this.gameService.activeGame.tourId
              .locale
              ? this.gameService.activeGame.tourId.locale
              : 'en';
              
              
              const isQRGame = !!this.gameService.activeGame.tourId?.isQR;
              const isEventHallGame = this.isEventHallGame();

              // 1) Raster layer setup (Virtual OR Event Hall)
              if (this.shouldShowRasterLayer()) {
                const rasterLayer = this.gameService.activeGame.partner.raster_image_url?.[0];
                this.setLevels(rasterLayer?.level || 1);
              } else {
                // Ensure we don't render stale layers from a previous game
                this.activeLayers = [];
              }

              // 2) Initial focus rules:
              // - Outdoor + Indoor (non-QR, non-event-hall): focus marker bounds immediately
              // - Event hall: focus raster immediately
              if (!isQRGame && !isEventHallGame) {
                const questsForBounds = this.getGameQuests?.() || this.gameService.activeGame.quests || [];
                const bounds = this.computeBoundsFromQuests(questsForBounds);
                if (bounds) {
                  this.activeBounds = bounds;
                }
                // If the map is already loaded, apply immediately; otherwise onMapLoad will do it.
                this.focusMapOnMarkers();
              } else if (isEventHallGame) {
                this.focusMapOnRaster();
              }
            
            this.gameService.originalQuests = data.data.quests;
            //this.gameService.activeGame.quests = data.data.quests;

            if (!this.gameService.activeGame.indoorMode) {
              this.getPlayers();
              this.initGame();
            } else {
              this.getPlayers();
            }

            setTimeout(() => {
              this.colorize();
            }, 1000);

            if (data.data.tourId.isGameTimer) {
              console.log("bejött")
              this.startGameCountdown();
            } else {
              this.terminateGameDueInactivity();
              console.log("Kiment")
            }
          }
        } else {
          console.log("big else")
          this.navigateBack();
        }
      });
  }

  navigateBack() {
    this.router.navigate(['/']);
  }

  ngOnInit() {
    if (this.utilsService.checkDeviceCompatibility()) {
      this.clearIntervals();
    }
  }

  ngAfterViewInit() {}
}